@if (externalUrl != ''){    
<iframe
  #questIframe
  [src]="iframeSrcSafe"
  class="iframe-container"
  referrerpolicy="no-referrer"
  sandbox="allow-scripts allow-forms allow-same-origin"
  allow="clipboard-read; clipboard-write"
></iframe>
}
